import { ITableFilterItem } from '@components/common/UTable/UTable';

import { RoleResponse } from '@/api/roles/types';
import { UserStatusLabel } from '@/shared/users/enums';
import { enumToOptions } from '@/utils/utils';

export const filterSchema = (
  allRoles: RoleResponse[],
  allOrgs?: any[],
): ITableFilterItem[] => [
  {
    label: 'ФИО',
    placeholder: 'Введите ФИО',
    key: 'fullName',
    type: 'text',
  },
  {
    label: 'Организация',
    placeholder: 'Выберите организацию',
    key: 'organizationId',
    type: 'cascader',
    payload: {
      options: allOrgs,
      fieldNames: {
        label: 'shortName',
        value: 'id',
        children: 'children',
      },
    },
  },
  {
    label: 'Роль',
    placeholder: 'Выберите роль',
    key: 'roleName',
    type: 'select',
    payload: {
      options: allRoles,
      fieldNames: {
        label: 'description',
        value: 'name',
      },
    },
  },
  {
    label: 'Статус',
    placeholder: 'Выберите статус',
    key: 'status',
    type: 'select',
    payload: {
      options: enumToOptions(UserStatusLabel),
    },
  },
];
